define('plugin/gallery/view/GalleryItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Gallery item view
     *
     * @class GalleryItemView
     */
    return LayoutView.extend({

        template: '#gallery_item_view'

    });

});
